import {Injectable} from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  endpoint = 'reports';
  constructor(private commonService: CommonService) { }

  async getDataToExport(uniqueId: string, isPublic: boolean = false) {
    try {
      let reportRequest;
      if (isPublic) {
        reportRequest = await this.commonService.getList(`${this.endpoint}/publicCustomFormsReport/export?uniqueId=${uniqueId}`);
      } else {
        reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsReport/export?uniqueId=${uniqueId}`);
      }
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getParentDataToExport(uniqueId: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsReport/parents/export?uniqueId=${uniqueId}`);
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getDataToExportByIdAndUniqueId(id, uniqueId) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsReport/export?uniqueId=${uniqueId}&id=${id}`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getLoginAttempts() {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/login-attempts`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getCustomFormsReport(completed?: number, formUniqueId?: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsReport?completed=${completed}&uniqueId=${formUniqueId}`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getCustomPublicFormsReport(completed?: number, formUniqueId?: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customPublicFormsReport?completed=${completed}&uniqueId=${formUniqueId}`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getCustomFormsReportForChildrenHistory() {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsReportForChildrenHistory`);
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getCustomFormsParentsReport(completed?: number, formUniqueId?: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customFormsParentReport?completed=${completed}&uniqueId=${formUniqueId}`);
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async validateParentForm(id: number, status: number) {
    try {
      const reportRequest: any = await this.commonService.updateItem(`${this.endpoint}/validateCustomFormsParentReport`, {id, status});
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async validateChildForm(id: number, status: number) {
    try {
      const reportRequest: any = await this.commonService.updateItem(`${this.endpoint}/validateCustomFormsChildReport`, {id, status});
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getFormReportUsers(uniqueId: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/getFormReportUsers?uniqueId=${uniqueId}`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getParentFormReportUsers(uniqueId: string) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/getParentFormReportUsers?uniqueId=${uniqueId}`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }

  async getCustomConsentsReport(completed?: number, formUniqueId?: string, history?: boolean) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customConsentsReport?completed=${completed}&uniqueId=${formUniqueId}&history=${history}`);
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getCustomAffirmationsReport(completed?: number, formUniqueId?: string, history?: boolean) {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/customAffirmationsReport?completed=${completed}&uniqueId=${formUniqueId}&history=${history}`);
      return reportRequest.object;

    } catch (e) {
      throw e;
    }
  }

  async getAnnouncementsReport() {
    try {
      const reportRequest = await this.commonService.getList(`${this.endpoint}/announcementsReport`);
      return reportRequest.object;
    } catch (e) {
      throw e;
    }
  }
}
